<script>
import PagenationContainer from "@/components/common/PagenationContainer.vue";

export default {
  components: {
    PagenationContainer
  },
  props: {
    myAgentList: Array,
    sourceData: Object
  },
  data() {
    const pageCount = this.sourceData.totalPages;
    return {
      checkBoxSelect: true,
      pageCount,
      activePage: this.sourceData.number + 1
    };
  },
  methods: {
    pageClick(page) {
      this.encodeToUrl({
        page: page
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      if(!val) val = 1;
      console.log(`当前页: ${val}`);
      this.activePage = val;
      let params = {
        page: this.activePage - 1
      };
      this.$emit("handleCurrentChange", "myAgent", params);
    },
    onClick(row) {
      console.log("router:" + row.id)
      this.$router.push(`/index/agentManage/agentDetail/${row.id}`);
      this.$router.go(0);
    }
  }
};
</script>

<template>
  <div class="my-agent-div">
    <el-table
      :data="myAgentList"
      @row-click="onClick"
      class="my-agent-list"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="companyName" align="left" label="公司名称" min-width="115"></el-table-column>
      <el-table-column prop="name" align="left" label="联系人" width="95"></el-table-column>
      <el-table-column prop="gender" align="left" label="性别" width="60"></el-table-column>
      <el-table-column prop="phone" align="left" label="联系电话" width="120"></el-table-column>
    </el-table>
    <PagenationContainer >
      <el-pagination
        @size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.my-agent-div {
  .my-agent-list {
    margin: 20px auto;
    border: 1px;
    width: 97%;
    .checkBoxLabel {
      color: #303133;
      .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: #303133;
      }
    }
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Agent/MyAgent.vue